export default {
  'Coupon.Loading': 'Loading...',
  'Coupon.ClaimSuccessful': 'Claim successful',
  'Coupon.rise': 'rise',
  'Coupon.full': 'full',
  'Coupon.available': 'available',
  'Coupon.PickUpAgain': 'Pick up again',
  'Coupon.ClaimItNow': 'Claim Now',
  'Coupon.Preferential': 'Preferential',
  'Coupon.MoreCoupons': 'More coupons'
};
